const extractSpecialties = (providerSpecialties = []) => {
  let specialtiesString = "";

  providerSpecialties.forEach(specialty => {
    specialtiesString += `${specialtiesString ? " " : ""}${
      specialty.specialty_nm
    }`;
  });

  return specialtiesString;
};

const buildDoctors = responseData => {
  if (responseData?.doctors?.length) {
    const doctorList = responseData.doctors.map(doctor => {
      const selectedData = doctor;
      const {
        pcp_flg,
        provider: { first_nm, last_nm, party_phone_faxes, provider_specialties }
      } = selectedData;
      let phoneNumber;

      if (party_phone_faxes.length) {
        const { phone_number, area_code } =
          party_phone_faxes[party_phone_faxes.length - 2];
        phoneNumber = `(${area_code}) ${phone_number.substring(
          0,
          3
        )}-${phone_number.substring(3)}`;
      }

      return {
        childrenData: {
          componentName: "Doctor",
          fullName: `${first_nm} ${last_nm}`,
          pcp: pcp_flg === "Y",
          specialties: extractSpecialties(provider_specialties),
          phoneNumber
        },
        key: "selectedData",
        type: "listItemWrapper",
        title: "",
        selectedData,
        childrenType: "doctor"
      };
    });

    return doctorList;
  }

  return [];
};

export default buildDoctors;
